import resizedEvent from '../../../utility/resized-event/js/resized-event';

// TODO: Use CustomEvent() instead of jQuery event
(function () {
    var enquireIt = {
        init: function () {
            // console.log("max-width:"+  (parseInt(UX.grid.screenSm) -1) +"px");
            // Responsive behavior controllers ( media query listeners )
            UX.controller.enabled = true;
            enquire /*eslint-disable-line*/
                .register('screen and (max-width:' + (parseInt(UX.grid.screenXs) - 1) + 'px)', {
                    match: function () {
                        enquireIt.dispatchEvent('screen-xs-on');
                    },
                    unmatch: function () {
                        enquireIt.dispatchEvent('screen-xs-off');
                    },
                })
                .register('screen and (max-width:' + (parseInt(UX.grid.screenSm) - 1) + 'px)', {
                    match: function () {
                        enquireIt.dispatchEvent('screen-sm-on');
                    },
                    unmatch: function () {
                        enquireIt.dispatchEvent('screen-sm-off');
                    },
                })
                .register('screen and (max-width:' + (parseInt(UX.grid.screenMd) - 1) + 'px)', {
                    match: function () {
                        enquireIt.dispatchEvent('screen-md-on');
                    },
                    unmatch: function () {
                        enquireIt.dispatchEvent('screen-md-off');
                    },
                })
                .register('screen and (max-width:' + (parseInt(UX.grid.screenLg) - 1) + 'px)', {
                    match: function () {
                        enquireIt.dispatchEvent('screen-lg-on');
                    },
                    unmatch: function () {
                        enquireIt.dispatchEvent('screen-lg-off');
                    },
                })
                .register('screen and (min-width:0px)', {
                    match: function () {
                        enquireIt.dispatchEvent('screen-xlg-on');
                    },
                    /*unmatch : function() {
                        $(document).trigger("screen-xlg-off"); // screen is not md anymore
                        $(document).trigger("smartResize"); // resize have been made

                    }*/
                })
                .register('screen and (max-width:' + (parseInt(UX.grid.articleLg) - 1) + 'px)', {
                    match: function () {
                        enquireIt.dispatchEvent('screen-article-lg-on');
                    },
                    unmatch: function () {
                        enquireIt.dispatchEvent('screen-article-lg-off');
                    },
                });

            resizedEvent();
        },

        dispatchEvent(event) {
            document.dispatchEvent(new Event(event));
            document.dispatchEvent(new Event('smartResize'));
        },
    };

    UX.enquireIt = enquireIt; // add to global namespace
})();
